import { CSSProperties } from 'react';
import { COLORS, FONTS, META } from '../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  group: {
    marginTop: '3.25rem',
  },
  groupHead: {
    fontFamily: FONTS.body,
    fontSize: '1.5rem',
    fontWeight: 600,
    color: COLORS.text,
    marginBottom: '1.25rem',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
  },
  detailText: {
    color: COLORS.muted,
    fontSize: '0.9rem',
    lineHeight: 1.7,
    maxWidth: '640px',
    marginBottom: '1.15rem',
  },
  detailTags: {
    display: 'flex',
    gap: '0.5rem',
    flexWrap: 'wrap',
    marginBottom: '1.25rem',
  },
  detailTag: {
    ...META,
    fontSize: '0.62rem',
    color: COLORS.faint,
    border: `1px solid ${COLORS.border}`,
    padding: '0.3rem 0.6rem',
  },
  detailLink: {
    ...META,
    fontSize: '0.68rem',
    color: COLORS.accent,
    textDecoration: 'none',
    cursor: 'pointer',
  },
};
